module.exports = __webpack_public_path__ + "static/media/ThankYouImage.3396b78d.svg";